module.exports = __webpack_public_path__ + "static/media/placeholder_dark.6b2c6655.png";